import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Load translation JSON files
  .use(HttpApi)
  // Automatically detect the language
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    // Fallback logic to handle languages without regions
    fallbackLng: {
      en: ['en-US'], // English falls back to US
      es: ['es-MX'], // Spanish falls back to Mexico
      pt: ['pt-BR'], // Portuguese falls back to Brazil
      default: ['en-US'], // Default language
    },
    detection: {
      // Priority for language detection: browser 1st
      order: ['localStorage', 'navigator'],
      // Save in localStorage only
      caches: ['localStorage'],
    },
    backend: {
      // Path to load translation files
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // Define the namespaces the project will use
    ns: [
      'auth',
      'sidebar',
      'inbox',
      'homeEmpty',
      'business',
      'users',
      'channel',
      'customers',
      'dashboard',
      'settings',
      'catalog',
      'lucci',
      'funnel',
      'campaigns',
      'chat',
      'reports',
    ],
    react: {
      // To avoid showing the loading screen while the translation is loading
      useSuspense: false,
    },
  });

export default i18n;
